export const translations = {
  de: {
    landing: {
      badge: 'Heiraten neu definiert',
      title: 'Wedding-O-Mat',
      subtitle: 'Entdecke in 15 Fragen deine Traumdestination für den schönsten Tag deines Lebens',
      startButton: 'Jetzt starten',
      howItWorks: 'Wie es funktioniert',
      step1Title: '15 Fragen',
      step1Desc: 'Beantworte Fragen zu Budget, Stil, Gästezahl und deinen persönlichen Vorlieben',
      step2Title: 'Inspirierende Bildergalerie',
      step2Desc: 'Entdecke während der Beantwortung passende Destinationen in einer eleganten Polaroid-Galerie',
      step3Title: 'Top {count} Empfehlungen',
      step3Desc: 'Erhalte deine perfekt abgestimmten Hochzeitsdestinationen mit allen Details',
      ctaTitle: 'Bereit für deine Traumhochzeit?',
      ctaDesc: 'Starte jetzt und entdecke die perfekte Destination für deinen besonderen Tag',
      ctaButton: 'Quiz starten',
      resumeQuiz: 'Quiz fortsetzen'
    },
    results: {
      navHome: 'Startseite',
      navLastQuestion: 'Letzte Frage',
      badge: 'Deine perfekten Hochzeitsdestinationen',
      title: 'Wir haben deine Traumdestinationen gefunden!',
      subtitle: 'Basierend auf deinen Antworten haben wir die {count} besten Destinationen für dich ausgewählt',
      whyMatch: 'Warum dieser Match?',
      saveButton: 'Per E-Mail senden',
      newSearchButton: 'Neue Suche starten',
      modalTitle: 'Ergebnisse per E-Mail erhalten',
      modalDesc: 'Gib deine Daten ein, um deine Top-Destinationen per E-Mail zu erhalten',
      name: 'Name',
      namePlaceholder: 'Dein Name',
      city: 'Ort',
      cityPlaceholder: 'Dein Ort',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'deine.email@beispiel.de',
      cancel: 'Abbrechen',
      send: 'Senden',
      sending: 'Wird gesendet...',
      errorEmail: 'Bitte gib eine gültige E-Mail-Adresse ein',
      errorName: 'Bitte gib deinen Namen ein',
      errorCity: 'Bitte gib deinen Ort ein',
      successMessage: 'Deine Ergebnisse wurden per E-Mail versendet!',
      errorMessage: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
      seasonMatches: 'Ihre gewünschte Hochzeitszeit passt perfekt zu dieser Destination',
      distanceMatches: 'Die Entfernung entspricht Ihren Vorstellungen',
      climateMatches: 'Das Klima ist genau wie von Ihnen gewünscht',
      scenarioMatches: 'Die Umgebung passt zu Ihrer Traumhochzeit',
      guestCount: 'Geeignet für Ihre geplante Gästezahl',
      budgetRange: 'Liegt in Ihrem gewünschten Budgetbereich',
      bestSeason: 'Beste Reisezeit',
      footerRetakeQuiz: 'Quiz wiederholen',
      footerSaveResults: 'Ergebnisse speichern & per E-Mail senden',
      footerBackHome: 'Zur Startseite'
    },
    quiz: {
      back: 'Zurück',
      progress: 'Frage {current} von {total}',
      videoTitle: 'Erzählen Sie uns mehr über Ihre Träume',
      videoCardTitle: 'Wedding-O-Mat Zwischenvideo',
      videoCardDescription: 'Kurze Pause während des Quiz',
      videoButton: 'Weiter',
      continueButton: 'Weiter',
      continueButtonWait: 'Bitte warten Sie {seconds} Sekunden...',
      matchingTitle: 'Passende Destinationen werden ermittelt...',
      matchingCount: '{count} von {total} Destinationen passen zu deiner Auswahl',
      errorMessage: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
    }
  },
  en: {
    landing: {
      badge: 'Redefining Marriage',
      title: 'Wedding-O-Mat',
      subtitle: 'Discover your dream destination in 15 questions for the most beautiful day of your life',
      startButton: 'Start Now',
      howItWorks: 'How It Works',
      step1Title: '15 Questions',
      step1Desc: 'Answer questions about budget, style, guest count, and your personal preferences',
      step2Title: 'Inspiring Image Gallery',
      step2Desc: 'Discover matching destinations in an elegant Polaroid gallery while answering',
      step3Title: 'Top {count} Recommendations',
      step3Desc: 'Get your perfectly matched wedding destinations with all details',
      ctaTitle: 'Ready for Your Dream Wedding?',
      ctaDesc: 'Start now and discover the perfect destination for your special day',
      ctaButton: 'Start Quiz',
      resumeQuiz: 'Resume Quiz'
    },
    results: {
      navHome: 'Home',
      navLastQuestion: 'Last Question',
      badge: 'Your Perfect Wedding Destinations',
      title: 'We Found Your Dream Destinations!',
      subtitle: 'Based on your answers, we selected the {count} best destinations for you',
      whyMatch: 'Why This Match?',
      saveButton: 'Send via Email',
      newSearchButton: 'Start New Search',
      modalTitle: 'Receive Results via Email',
      modalDesc: 'Enter your details to receive your top destinations via email',
      name: 'Name',
      namePlaceholder: 'Your Name',
      city: 'City',
      cityPlaceholder: 'Your City',
      email: 'Email Address',
      emailPlaceholder: 'your.email@example.com',
      cancel: 'Cancel',
      send: 'Send',
      sending: 'Sending...',
      errorEmail: 'Please enter a valid email address',
      errorName: 'Please enter your name',
      errorCity: 'Please enter your city',
      successMessage: 'Your results have been sent via email!',
      errorMessage: 'An error occurred. Please try again.',
      seasonMatches: 'Your desired wedding time perfectly matches this destination',
      distanceMatches: 'The distance matches your preferences',
      climateMatches: 'The climate is exactly as you requested',
      scenarioMatches: 'The environment suits your dream wedding',
      guestCount: 'Suitable for your planned guest count',
      budgetRange: 'Within your desired budget range',
      bestSeason: 'Best Travel Time',
      footerRetakeQuiz: 'Retake Quiz',
      footerSaveResults: 'Save Results & Send via Email',
      footerBackHome: 'Back to Home'
    },
    quiz: {
      back: 'Back',
      progress: 'Question {current} of {total}',
      videoTitle: 'Tell Us More About Your Dreams',
      videoCardTitle: 'Wedding-O-Mat Interlude Video',
      videoCardDescription: 'Short break during the quiz',
      videoButton: 'Continue',
      continueButton: 'Continue',
      continueButtonWait: 'Please wait {seconds} seconds...',
      matchingTitle: 'Finding Matching Destinations...',
      matchingCount: '{count} of {total} destinations match your selection',
      errorMessage: 'An error occurred. Please try again.'
    }
  },
  es: {
    landing: {
      badge: 'Redefiniendo el Matrimonio',
      title: 'Wedding-O-Mat',
      subtitle: 'Descubre tu destino soñado en 15 preguntas para el día más hermoso de tu vida',
      startButton: 'Empezar Ahora',
      howItWorks: 'Cómo Funciona',
      step1Title: '15 Preguntas',
      step1Desc: 'Responde preguntas sobre presupuesto, estilo, número de invitados y tus preferencias personales',
      step2Title: 'Galería de Imágenes Inspiradora',
      step2Desc: 'Descubre destinos coincidentes en una elegante galería Polaroid mientras respondes',
      step3Title: 'Mejores {count} Recomendaciones',
      step3Desc: 'Obtén tus destinos de boda perfectamente combinados con todos los detalles',
      ctaTitle: '¿Listo para Tu Boda de Ensueño?',
      ctaDesc: 'Comienza ahora y descubre el destino perfecto para tu día especial',
      ctaButton: 'Iniciar Quiz',
      resumeQuiz: 'Reanudar Quiz'
    },
    results: {
      navHome: 'Inicio',
      navLastQuestion: 'Última Pregunta',
      badge: 'Tus Destinos de Boda Perfectos',
      title: '¡Encontramos Tus Destinos de Ensueño!',
      subtitle: 'Basado en tus respuestas, seleccionamos los {count} mejores destinos para ti',
      whyMatch: '¿Por Qué Esta Coincidencia?',
      saveButton: 'Enviar por Email',
      newSearchButton: 'Iniciar Nueva Búsqueda',
      modalTitle: 'Recibir Resultados por Email',
      modalDesc: 'Ingresa tus datos para recibir tus mejores destinos por email',
      name: 'Nombre',
      namePlaceholder: 'Tu Nombre',
      city: 'Ciudad',
      cityPlaceholder: 'Tu Ciudad',
      email: 'Correo Electrónico',
      emailPlaceholder: 'tu.email@ejemplo.com',
      cancel: 'Cancelar',
      send: 'Enviar',
      sending: 'Enviando...',
      errorEmail: 'Por favor ingresa un correo electrónico válido',
      errorName: 'Por favor ingresa tu nombre',
      errorCity: 'Por favor ingresa tu ciudad',
      successMessage: '¡Tus resultados han sido enviados por email!',
      errorMessage: 'Ocurrió un error. Por favor intenta de nuevo.',
      seasonMatches: 'Tu época de boda deseada coincide perfectamente con este destino',
      distanceMatches: 'La distancia coincide con tus preferencias',
      climateMatches: 'El clima es exactamente como lo solicitaste',
      scenarioMatches: 'El entorno se adapta a tu boda de ensueño',
      guestCount: 'Adecuado para tu número de invitados planeado',
      budgetRange: 'Dentro de tu rango de presupuesto deseado',
      bestSeason: 'Mejor Época de Viaje',
      footerRetakeQuiz: 'Repetir Quiz',
      footerSaveResults: 'Guardar Resultados & Enviar por Email',
      footerBackHome: 'Volver al Inicio'
    },
    quiz: {
      back: 'Atrás',
      progress: 'Pregunta {current} de {total}',
      videoTitle: 'Cuéntanos Más Sobre Tus Sueños',
      videoCardTitle: 'Video Intermedio Wedding-O-Mat',
      videoCardDescription: 'Breve pausa durante el quiz',
      videoButton: 'Continuar',
      continueButton: 'Continuar',
      continueButtonWait: 'Por favor espera {seconds} segundos...',
      matchingTitle: 'Encontrando Destinos Coincidentes...',
      matchingCount: '{count} de {total} destinos coinciden con tu selección',
      errorMessage: 'Ocurrió un error. Por favor intenta de nuevo.'
    }
  }
};

export const countryTranslations = {
  de: {
    'Spanien Festland': 'Spanien Festland',
    'Mallorca': 'Mallorca',
    'Ibiza': 'Ibiza',
    'Italien': 'Italien',
    'Malta': 'Malta',
    'Südtirol': 'Südtirol',
    'Sizilien': 'Sizilien',
    'Sardinien': 'Sardinien',
    'Zypern': 'Zypern',
    'Portugal Festland': 'Portugal Festland',
    'Madeira': 'Madeira',
    'Azoren': 'Azoren',
    'Kapverden': 'Kapverden',
    'Kreta': 'Kreta',
    'Korsika': 'Korsika',
    'Griechenland & Inseln': 'Griechenland & Inseln',
    'Kroatien': 'Kroatien',
    'Österreicher Alpen (Schnee)': 'Österreicher Alpen (Schnee)',
    'Österreicher Alpen': 'Österreicher Alpen',
    'Schweizer Alpen (Schnee)': 'Schweizer Alpen (Schnee)',
    'Schweizer Alpen': 'Schweizer Alpen',
    'Polen': 'Polen',
    'Frankreich': 'Frankreich',
    'Norwegen': 'Norwegen',
    'Island (Schnee)': 'Island (Schnee)',
    'Island': 'Island',
    'Dänemark': 'Dänemark',
    'Ungarn': 'Ungarn',
    'Türkei': 'Türkei',
    'England': 'England',
    'Irland': 'Irland',
    'Jordanien': 'Jordanien',
    'Oman': 'Oman',
    'Dubai': 'Dubai',
    'Sri Lanka': 'Sri Lanka',
    'Thailand': 'Thailand',
    'Vietnam': 'Vietnam',
    'Malediven': 'Malediven',
    'Seychellen': 'Seychellen',
    'China': 'China',
    'Japan': 'Japan',
    'Indonesien': 'Indonesien',
    'Philippinen': 'Philippinen',
    'Mongolei': 'Mongolei',
    'Südafrika': 'Südafrika',
    'Namibia': 'Namibia',
    'Tansania': 'Tansania',
    'Kenia': 'Kenia',
    'Ägypten': 'Ägypten',
    'Marokko': 'Marokko',
    'Brasilien': 'Brasilien',
    'Argentinien': 'Argentinien',
    'Chile': 'Chile',
    'Peru': 'Peru',
    'Ecuador': 'Ecuador',
    'Kolumbien': 'Kolumbien',
    'Costa Rica': 'Costa Rica',
    'Panama': 'Panama',
    'Mexiko': 'Mexiko',
    'Dominikanische Republik': 'Dominikanische Republik',
    'Aruba': 'Aruba',
    'St. Lucia': 'St. Lucia',
    'Barbados': 'Barbados',
    'Guadeloupe | Dominica': 'Guadeloupe | Dominica',
    'USA': 'USA',
    'Hawaii': 'Hawaii',
    'Australien': 'Australien'
  },
  en: {
    'Spanien Festland': 'Mainland Spain',
    'Mallorca': 'Mallorca',
    'Ibiza': 'Ibiza',
    'Italien': 'Italy',
    'Malta': 'Malta',
    'Südtirol': 'South Tyrol',
    'Sizilien': 'Sicily',
    'Sardinien': 'Sardinia',
    'Zypern': 'Cyprus',
    'Portugal Festland': 'Mainland Portugal',
    'Madeira': 'Madeira',
    'Azoren': 'Azores',
    'Kapverden': 'Cape Verde',
    'Kreta': 'Crete',
    'Korsika': 'Corsica',
    'Griechenland & Inseln': 'Greece & Islands',
    'Kroatien': 'Croatia',
    'Österreicher Alpen (Schnee)': 'Austrian Alps (Snow)',
    'Österreicher Alpen': 'Austrian Alps',
    'Schweizer Alpen (Schnee)': 'Swiss Alps (Snow)',
    'Schweizer Alpen': 'Swiss Alps',
    'Polen': 'Poland',
    'Frankreich': 'France',
    'Norwegen': 'Norway',
    'Island (Schnee)': 'Iceland (Snow)',
    'Island': 'Iceland',
    'Dänemark': 'Denmark',
    'Ungarn': 'Hungary',
    'Türkei': 'Turkey',
    'England': 'England',
    'Irland': 'Ireland',
    'Jordanien': 'Jordan',
    'Oman': 'Oman',
    'Dubai': 'Dubai',
    'Sri Lanka': 'Sri Lanka',
    'Thailand': 'Thailand',
    'Vietnam': 'Vietnam',
    'Malediven': 'Maldives',
    'Seychellen': 'Seychelles',
    'China': 'China',
    'Japan': 'Japan',
    'Indonesien': 'Indonesia',
    'Philippinen': 'Philippines',
    'Mongolei': 'Mongolia',
    'Südafrika': 'South Africa',
    'Namibia': 'Namibia',
    'Tansania': 'Tanzania',
    'Kenia': 'Kenya',
    'Ägypten': 'Egypt',
    'Marokko': 'Morocco',
    'Brasilien': 'Brazil',
    'Argentinien': 'Argentina',
    'Chile': 'Chile',
    'Peru': 'Peru',
    'Ecuador': 'Ecuador',
    'Kolumbien': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Panama': 'Panama',
    'Mexiko': 'Mexico',
    'Dominikanische Republik': 'Dominican Republic',
    'Aruba': 'Aruba',
    'St. Lucia': 'St. Lucia',
    'Barbados': 'Barbados',
    'Guadeloupe | Dominica': 'Guadeloupe | Dominica',
    'USA': 'USA',
    'Hawaii': 'Hawaii',
    'Australien': 'Australia'
  },
  es: {
    'Spanien Festland': 'España Continental',
    'Mallorca': 'Mallorca',
    'Ibiza': 'Ibiza',
    'Italien': 'Italia',
    'Malta': 'Malta',
    'Südtirol': 'Tirol del Sur',
    'Sizilien': 'Sicilia',
    'Sardinien': 'Cerdeña',
    'Zypern': 'Chipre',
    'Portugal Festland': 'Portugal Continental',
    'Madeira': 'Madeira',
    'Azoren': 'Azores',
    'Kapverden': 'Cabo Verde',
    'Kreta': 'Creta',
    'Korsika': 'Córcega',
    'Griechenland & Inseln': 'Grecia e Islas',
    'Kroatien': 'Croacia',
    'Österreicher Alpen (Schnee)': 'Alpes Austriacos (Nieve)',
    'Österreicher Alpen': 'Alpes Austriacos',
    'Schweizer Alpen (Schnee)': 'Alpes Suizos (Nieve)',
    'Schweizer Alpen': 'Alpes Suizos',
    'Polen': 'Polonia',
    'Frankreich': 'Francia',
    'Norwegen': 'Noruega',
    'Island (Schnee)': 'Islandia (Nieve)',
    'Island': 'Islandia',
    'Dänemark': 'Dinamarca',
    'Ungarn': 'Hungría',
    'Türkei': 'Turquía',
    'England': 'Inglaterra',
    'Irland': 'Irlanda',
    'Jordanien': 'Jordania',
    'Oman': 'Omán',
    'Dubai': 'Dubái',
    'Sri Lanka': 'Sri Lanka',
    'Thailand': 'Tailandia',
    'Vietnam': 'Vietnam',
    'Malediven': 'Maldivas',
    'Seychellen': 'Seychelles',
    'China': 'China',
    'Japan': 'Japón',
    'Indonesien': 'Indonesia',
    'Philippinen': 'Filipinas',
    'Mongolei': 'Mongolia',
    'Südafrika': 'Sudáfrica',
    'Namibia': 'Namibia',
    'Tansania': 'Tanzania',
    'Kenia': 'Kenia',
    'Ägypten': 'Egipto',
    'Marokko': 'Marruecos',
    'Brasilien': 'Brasil',
    'Argentinien': 'Argentina',
    'Chile': 'Chile',
    'Peru': 'Perú',
    'Ecuador': 'Ecuador',
    'Kolumbien': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Panama': 'Panamá',
    'Mexiko': 'México',
    'Dominikanische Republik': 'República Dominicana',
    'Aruba': 'Aruba',
    'St. Lucia': 'Santa Lucía',
    'Barbados': 'Barbados',
    'Guadeloupe | Dominica': 'Guadalupe | Dominica',
    'USA': 'EE.UU.',
    'Hawaii': 'Hawái',
    'Australien': 'Australia'
  }
};

export const continentTranslations = {
  de: {
    'Europa': 'Europa',
    'Asien': 'Asien',
    'Afrika': 'Afrika',
    'Amerika': 'Amerika',
    'Ozeanien': 'Ozeanien'
  },
  en: {
    'Europa': 'Europe',
    'Asien': 'Asia',
    'Afrika': 'Africa',
    'Amerika': 'Americas',
    'Ozeanien': 'Oceania'
  },
  es: {
    'Europa': 'Europa',
    'Asien': 'Asia',
    'Afrika': 'África',
    'Amerika': 'América',
    'Ozeanien': 'Oceanía'
  }
};

export const monthTranslations = {
  de: {
    'Januar-Februar': 'Januar-Februar',
    'März-April': 'März-April',
    'Mai-Juni': 'Mai-Juni',
    'Juli-August': 'Juli-August',
    'September-Oktober': 'September-Oktober',
    'November-Dezember': 'November-Dezember'
  },
  en: {
    'Januar-Februar': 'January-February',
    'März-April': 'March-April',
    'Mai-Juni': 'May-June',
    'Juli-August': 'July-August',
    'September-Oktober': 'September-October',
    'November-Dezember': 'November-December'
  },
  es: {
    'Januar-Februar': 'Enero-Febrero',
    'März-April': 'Marzo-Abril',
    'Mai-Juni': 'Mayo-Junio',
    'Juli-August': 'Julio-Agosto',
    'September-Oktober': 'Septiembre-Octubre',
    'November-Dezember': 'Noviembre-Diciembre'
  }
};

export const t = (key, lang = 'de', params = {}) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  if (typeof value === 'string') {
    return value.replace(/{(\w+)}/g, (match, param) => params[param] || match);
  }
  
  return key;
};

export const translateCountry = (countryName, lang = 'de') => {
  return countryTranslations[lang]?.[countryName] || countryName;
};

export const translateContinent = (continentName, lang = 'de') => {
  return continentTranslations[lang]?.[continentName] || continentName;
};

export const translateMonth = (monthPeriod, lang = 'de') => {
  return monthTranslations[lang]?.[monthPeriod] || monthPeriod;
};
